import { Col, Row } from "react-bootstrap";
import { EApplicationType } from "../../../../shared/oversight-core/enums/application-type";
import { EEnergyNeedEditParameter } from "../../../../shared/oversight-core/enums/energy-need-edit-parameters";
import { EUtilityOptionType } from "../../../../shared/oversight-core/enums/utility-option-type";
import AppDropDown from "../../../../shared/oversight-core/ui-elements/app-dropdown/app-drop-down";
import { Option } from "../../../../shared/oversight-core/ui-elements/app-select/app-select";
import MaterialIcon from "../../../../shared/oversight-core/ui-elements/material-icon/material-icon";

interface IProps {
  onParameterEdit?: (type: EEnergyNeedEditParameter) => void;
  waterDemand: number;
  totalLiters: number;
  numberOfUsers: number;
  isHideEditIcon?: boolean;
  applicationType: Option;
  utilityOption: Option;
  onApplicationTypeChange: (option: Option) => void;
  onUtilityOptionChange: (option: Option) => void;
  onDeleteWaterHeaterSystem?: () => void;
  isHideDeleteIcon?: boolean;
}

const SelectedWaterHeaterSystemCard = (props: IProps) => {
  const {
    onParameterEdit,
    waterDemand,
    totalLiters,
    numberOfUsers,
    isHideEditIcon = false,
    isHideDeleteIcon = false,
    applicationType,
    utilityOption,
    onApplicationTypeChange,
    onUtilityOptionChange,
    onDeleteWaterHeaterSystem,
  } = props;

  return (
    <div className="theme-card-3 p-3 rounded-3 h-100">
      <Row className="row-cols-auto justify-content-between align-items-center gx-2">
        <Col>
          <Row className="row-cols-auto flex-column flex-md-row align-items-md-end justify-content-md-between">
            <Col>
              <Row className="flex-row flex-md-column gy-2">
                <Col>
                  <MaterialIcon
                    icon="water_drop"
                    color="var(--color-system-icon)"
                    fill
                  />
                </Col>
                <Col className="text-color-4 font-weight-500 font-size-14">
                  Required
                </Col>
                <Col className="text-color-4 font-weight-500 font-size-14">
                  Selected
                </Col>
              </Row>
            </Col>
            <Col>
              <Row className="flex-row flex-md-column gy-2">
                <Col className="text-color-4 font-weight-400 font-size-12">
                  Water Demand
                </Col>
                <Col>
                  <Row className="row-cols-auto align-items-center">
                    <Col className="text-setting-item-selected font-weight-600 font-size-13 pe-0">
                      {`${waterDemand}L`}
                    </Col>
                  </Row>
                </Col>
                <Col className="font-weight-700 status-approved">
                  {`${totalLiters}L`}
                </Col>
              </Row>
            </Col>
            <Col>
              <Row
                className={`flex-row flex-md-column ${
                  isHideEditIcon ? "gy-2" : "gy-1"
                }`}
              >
                <Col className="text-color-4 font-weight-400 font-size-12">
                  Application Type
                </Col>
                <Col>
                  <Row className="row-cols-auto align-items-center">
                    <Col className="text-setting-item-selected font-weight-600 font-size-13 pe-0">
                      {applicationType.label}
                    </Col>
                    {!isHideEditIcon && (
                      <Col className="ps-2">
                        <AppDropDown
                          items={[
                            {
                              onClick: () => {
                                onApplicationTypeChange({
                                  value: EApplicationType.RESIDENTIAL,
                                  label: "Residential",
                                });
                              },
                              text: "Residential",
                            },
                            {
                              onClick: () => {
                                onApplicationTypeChange({
                                  value: EApplicationType.HOTELS,
                                  label: "Hotels",
                                });
                              },
                              text: "Hotels",
                            },
                            {
                              onClick: () => {
                                onApplicationTypeChange({
                                  value: EApplicationType.HOSTELS,
                                  label: "Hostels",
                                });
                              },
                              text: "Hostels",
                            },
                            {
                              onClick: () => {
                                onApplicationTypeChange({
                                  value: EApplicationType.SCHOOLS,
                                  label: "Schools",
                                });
                              },
                              text: "Schools",
                            },
                          ]}
                          icon="arrow_drop_down"
                          showBackgroundAndBorder={false}
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col className="font-weight-700 status-approved">
                  {applicationType.label}
                </Col>
              </Row>
            </Col>
            <Col>
              <Row className="flex-row flex-md-column gy-2">
                <Col className="text-color-4 font-weight-400 font-size-12">
                  No. of Users
                </Col>
                <Col>
                  <Row className="row-cols-auto align-items-center">
                    <Col className="text-setting-item-selected font-weight-600 font-size-13 pe-0">
                      {numberOfUsers}
                    </Col>
                    {!isHideEditIcon && (
                      <Col className="ps-2">
                        <MaterialIcon
                          icon="border_color"
                          className="cursor-pointer"
                          color="var(--color-edit-icon-2)"
                          size={14}
                          onClick={() => {
                            onParameterEdit?.(
                              EEnergyNeedEditParameter.NO_OF_USERS
                            );
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col className="font-weight-700 status-approved">
                  {numberOfUsers}
                </Col>
              </Row>
            </Col>
            <Col>
              <Row
                className={`flex-row flex-md-column ${
                  isHideEditIcon ? "gy-2" : "gy-1"
                }`}
              >
                <Col className="text-color-4 font-weight-400 font-size-12">
                  Utility
                </Col>
                <Col>
                  <Row className="row-cols-auto align-items-center">
                    <Col className="text-setting-item-selected font-weight-600 font-size-13 pe-0">
                      {utilityOption.label}
                    </Col>
                    {!isHideEditIcon && (
                      <Col className="ps-2">
                        <AppDropDown
                          items={[
                            {
                              onClick: () => {
                                onUtilityOptionChange({
                                  value: EUtilityOptionType.SHOWER,
                                  label: "Shower",
                                });
                              },
                              text: "Shower",
                            },
                            {
                              onClick: () => {
                                onUtilityOptionChange({
                                  value: EUtilityOptionType.BATHTUB_JACUZZI,
                                  label: "Bathtub/Jacuzzi",
                                });
                              },
                              text: "Bathtub/Jacuzzi",
                            },
                          ]}
                          icon="arrow_drop_down"
                          showBackgroundAndBorder={false}
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col className="font-weight-700 status-approved">
                  {utilityOption.label}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        {!isHideDeleteIcon && (
          <Col>
            <MaterialIcon
              icon="delete"
              color="#E63E35"
              size={18}
              className="cursor-pointer"
              onClick={onDeleteWaterHeaterSystem}
            />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default SelectedWaterHeaterSystemCard;
